import { PROVIDER_LABEL } from '../ControlPanel/constants';

export const getProviderLabel = (provider: string) => PROVIDER_LABEL[provider as keyof typeof PROVIDER_LABEL];
